import { axios, def, handleError, handleResponse } from './internal';
import { storage } from '@goldblack/client-storage';

function AdminUserChangeNsfw(userId, type, set, onSuccess) {
    axios
        .post('/api/admin_user_changensfw', { userId, type, set })
        .then((res) => {
            switch (res.data.code) {
                case def.ErrorCode.OK:
                    storage.transience.setState(
                        'internal.success',
                        set ? `Restriction (${type}) set.` : `Restriction (${type}) cleared.`,
                    );
                    if (onSuccess) onSuccess(res.data.data.nsfw, type);
                    break;
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => handleError(err));
}

export { AdminUserChangeNsfw };
